import { createAsyncThunk } from "@reduxjs/toolkit";

import { SentinelLoadingStatus } from "./types";
import { SentinelController } from "./controller";
import { SubmitOnboardingRequestInput, GetTeamPackageListCommandInput, GetPackageDependencyListCommandInput } from "@amzn/dependencysentinel";

export const submitOnboardingRequest = createAsyncThunk(
    "sentinel/submitOnboardingRequest",
    async (payload: {
    sentinelController: SentinelController;
    onboardingRequestInput: SubmitOnboardingRequestInput;
  }) => {
        const response = await payload.sentinelController.submitOnboardingRequest(
            payload.onboardingRequestInput,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    },
);

export const getOnboardedTeams = createAsyncThunk(
    "sentinel/getOnboardedTeams",
    async (payload: { sentinelController: SentinelController; requesterId?: string }) => {
        const response = await payload.sentinelController.getOnboardedTeams(payload.requesterId);
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    }
);

export const getTeamPipelines = createAsyncThunk(
    "sentinel/getTeamPipelines",
    async (payload: {
    sentinelController: SentinelController;
    teamId: string;
  }) => {
        const response = await payload.sentinelController.getTeamPipelines(
            payload.teamId,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    }
);

export const getPipelinePackages = createAsyncThunk(
    "sentinel/getPipelinePackages",
    async (payload: {
    sentinelController: SentinelController;
    pipelineName: string;
  }) => {
        const response = await payload.sentinelController.getPipelinePackages(
            payload.pipelineName,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    }
);

export const getTeamPackageList = createAsyncThunk(
    "sentinel/getTeamPackages",
    async (payload: { 
    sentinelController: SentinelController;
    teamPackageListInput: GetTeamPackageListCommandInput;
  }) => {
        const response = await payload.sentinelController.getTeamPackageList(
            payload.teamPackageListInput
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    }
);

export const getPackageDependencyList = createAsyncThunk(
    "sentinel/getPackageDependencyList",
    async (payload: {
    sentinelController: SentinelController;
    packageDependencyListInput: GetPackageDependencyListCommandInput;
  }) => {
        const response = await payload.sentinelController.getPackageDependencyList(
            payload.packageDependencyListInput
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    }
);

export const getCodeReviewsByTeam = createAsyncThunk(
    "sentinel/getCodeReviewsByTeam",
    async (payload: {
    sentinelController: SentinelController;
    teamName: string;
  }) => {
        const response = await payload.sentinelController.getCodeReviewsByTeam(
            payload.teamName,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    }
);

export const submitPackageDryRunUpgrades = createAsyncThunk(
    "sentinel/submitPackageDryRunUpgrades",
    async (payload: {
    sentinelController: SentinelController;
    packageName: string;
  }) => {
        const response = await payload.sentinelController.submitPackageDryRunUpgrades(
            payload.packageName,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    },
);

export const getPackageDryRunUpgradesResult = createAsyncThunk(
    "sentinel/getPackageDryRunUpgradesResult",
    async (payload: {
    sentinelController: SentinelController;
    requestId: string;
  }) => {
        const response = await payload.sentinelController.getPackageDryRunUpgradesResult(
            payload.requestId,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    },
);

export const echo = createAsyncThunk(
    "sentinel/echo",
    async (payload: { sentinelController: SentinelController; message: string }) => {
        const response = await payload.sentinelController.echo(payload.message);
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    },
);

export const getUserPipelines = createAsyncThunk(
    "sentinel/getUserPipelines",
    async (payload: {
        sentinelController: SentinelController;
        userId: string;
    }) => {
        const response = await payload.sentinelController.getUserPipelines(
            payload.userId,
        );
        return {
            status: SentinelLoadingStatus.FINISHED,
            payload: response,
        };
    },
);
